import React from "react";
import { h, Component } from "preact";
import "./style.scss";

export default class Style extends Component {
    render() {
        let styles = this.props.styles.config;

        const fontSizesMap = {
            "sm": 12,
            "md": 16,
            "lg": 20,
        };

        const fontSize = fontSizesMap[styles.global_font_size];
        return (
            <style type="text/css">
                {`:root {
                    --font-family: ${styles.global_font_family};
                    --font-size: ${fontSize}px;

                    --bubble-size: ${styles.button_size}px;
                    --bubble-color: ${styles.button_icon_color};
                    --bubble-bg-color: ${styles.button_bg_color};

                    --window-position: ${styles.button_position};
                    --window-width: 350px;
                    --window-height: 600px;
                    --window-header-height: 60px;
                    --window-footer-height: 40px;
                    --window-body-height: 500px;

                    --header-color: ${styles.window_header_color};
                    --header-bg-color: ${styles.window_header_bg};

                    --file-name-color: ${styles.user_input_file_name_color};
                    --textarea-bg-color: ${styles.user_input_bg};
                    --textarea-color: ${styles.user_input_text_color};
                    --textarea-placeholder-color: ${
                        styles.user_input_placeholder_color
                    };

                    --send-btn-bg-color: ${styles.user_input_send_button_bg};
                    --send-btn-color: ${styles.user_input_send_button_color};

                    --menu-color: ${styles.menu_item_color};
                    --menu-bg-color: ${styles.menu_bg};

                    --footer-color: ${styles.window_footer_color};
                    --footer-bg-color: ${styles.window_footer_bg};

                    --menu-badge-color: ${styles.menu_badge_bg};
                    --menu-badge-text-color:  ${styles.menu_badge_color};

                    --window-body-bg-color: ${styles.content_bg};

                    --start-btn-bg: ${styles.start_btn_bg};
                    --start-btn-color: ${styles.start_btn_color};

                    --message-income-bg-color: ${styles.bot_or_operator_msg_bg};
                    --message-income-color: ${styles.bot_or_operator_msg_color};
                    --message-income-btn-bg-color: ${styles.bot_message_button_bg};
                    --message-income-btn-color: ${styles.bot_message_button_color};

                    --message-outcome-bg-color: ${styles.user_message_bg};
                    --message-outcome-color: ${styles.user_message_color};

                    --card-width: ${styles.card_width}px;
                    --card-height: ${styles.card_height}px;

                    --card-image-percent: ${styles.card_image_percent}%;

                    --card-image-object-fit: ${styles.card_image_object_fit};
                    --card-image-object-border-width: ${styles.card_image_object_border_width}px;
                    --card-image-object-border-color: ${styles.card_image_object_border_color};
                    --card-image-object-border-style: ${styles.card_image_object_border_style};

                    --card-title-font-size: ${styles.card_title_font_size}px;
                    --card-title-align: ${styles.card_title_align};
                    --card-title-color: ${styles.card_title_color};

                    --card-link-button-bg: ${styles.card_link_button_bg};
                    --card-link-button-color: ${styles.card_link_button_color};

                    --card-action-button-bg: ${styles.card_action_button_bg};
                    --card-action-button-color: ${styles.card_action_button_color};


                }

                .speech-bubble-wrapper {
                    animation: ${
                        styles.button_animation
                            ? "play 1.5s ease infinite"
                            : "none"
                    };
                }
                .menu-btn .badge {
                    display: ${styles.menu_show_badge ? "block" : "none"};
                }
                `}
            </style>
        );
    }
}



// WEBPACK FOOTER //
// ./styles/Style.js